import React from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ThirdPartyAccessoryProvider } from '@upstart/harmony/lib/constants';
import './Accessories.scss';

export const AccessoryDropDown = ({
  updatethirdPartyAccessoryProvider,
  thirdPartyAccessoryProvider,
}) => {
  const accessoryDropDownLabel = () => {
    if (
      thirdPartyAccessoryProvider ===
      ThirdPartyAccessoryProvider.ShiftDigitalFTP
    ) {
      return 'Subaru';
    }
    if (thirdPartyAccessoryProvider === ThirdPartyAccessoryProvider.Insignia) {
      return 'Insignia';
    }
    return 'None';
  };

  return (
    <div className="accessory-dropdown-container">
      <h4>Third Party Accessory Feed</h4>
      <p id="accessory-dropdown-memo">{`(requires re-import to take effect)`}</p>
      <Dropdown className="dropdown dropdown-trigger" id="accessory-dropdown">
        <Dropdown.Toggle className="dropdown-label">
          {accessoryDropDownLabel()}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem
            key={1}
            onSelect={() =>
              updatethirdPartyAccessoryProvider(
                ThirdPartyAccessoryProvider.Insignia,
              )
            }
          >
            Insignia
          </MenuItem>
          <MenuItem
            key={2}
            onSelect={() =>
              updatethirdPartyAccessoryProvider(
                ThirdPartyAccessoryProvider.ShiftDigitalFTP,
              )
            }
          >
            Subaru (requires shift digital configuration)
          </MenuItem>
          <MenuItem
            key={3}
            onSelect={() => updatethirdPartyAccessoryProvider(null)}
          >
            None
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

AccessoryDropDown.propTypes = {
  updatethirdPartyAccessoryProvider: PropTypes.func,
  thirdPartyAccessoryProvider: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.any,
  ]),
};
